import { Outlet, createRootRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { Toaster } from "sonner";

function RootComponent() {
  // Set document language once.
  useEffect(() => {
    document.documentElement.setAttribute("lang", "es");
  }, []);

  return (
    <>
      <Outlet />
      {/* Sonner toast root. Theme inherits from `:root[data-theme]`. */}
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
      {/* TanStack Router devtools are dev-only; kept lightweight here.
          Lazy import is wired in UC-10.07 alongside the real toggles. */}
    </>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
